import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="controller-filter"
export default class extends Controller {
  static targets = [ "allSelect", "tixer", "selectedCount", "footer", "partModalButton", "messageModalButton", "partCheckbox" ]

  toggleAll() {
    if (this.allSelectTarget.checked == true) {
      this.tixerTargets.forEach((tixer) => {
        tixer.checked = true
      })
    } else {
      this.tixerTargets.forEach((tixer) => {
        tixer.checked = false
      })
    }
    this.updateTixerCount()
  }

  onCheck() {
    this.updateTixerCount()
  }

  selectAll() {
    this.tixerTargets.forEach((tixer) => {
      tixer.checked = true
      this.allSelectTarget.checked = true
    })
    this.updateTixerCount()
  }
  
  unselectAll() {
    this.tixerTargets.forEach((tixer) => {
      tixer.checked = false
      this.allSelectTarget.checked = false
    })
    this.updateTixerCount()
  }

  openPartModal() {
    this.partModalButtonTarget.click();
  }

  openMessageModal() {
    this.messageModalButtonTarget.click();
  }

  // Part openning modal

  onPartCheck(e) {
    const clickedPart = e.target
    this.partCheckboxTargets.forEach((partCheckbox) => {
      if (clickedPart.checked == true) {
        if (parseInt(partCheckbox.dataset.order) <= clickedPart.dataset.order) {
          partCheckbox.checked = true
        } else {
          partCheckbox.checked = false
        }
      } else if (clickedPart.checked == false) {
        if (parseInt(partCheckbox.dataset.order) >= clickedPart.dataset.order) {
          partCheckbox.checked = false
        }
      }
    })
  }

  // private

  updateTixerCount() {
    const selected = this.tixerTargets.filter(tixer => tixer.checked == true)
    const selectedCount = selected.length
    this.selectedCountTargets.forEach(target => target.innerHTML = selectedCount)

    if (selectedCount == 0) {
      this.footerTarget.classList.add("d-none")
    } else {
      this.footerTarget.classList.remove("d-none")
    }

    const selectedID = selected.map(tixer => parseInt(tixer.id.split("_")[1]))
    const message_tixer_ids_input = document.getElementById("message_tixer_ids")
    message_tixer_ids_input.value = JSON.stringify(selectedID)
    const part_tixer_ids_input = document.getElementById("part_tixer_ids")
    part_tixer_ids_input.value = JSON.stringify(selectedID)
  }
}